module.exports = __webpack_public_path__ + "img/10sc.000bc9da.png";